import { cn } from "@/lib/utils";

interface StoryAvatarProps {
  avatarUrl: string;
  name: string;
  viewed: boolean;
  onClick: () => void;
}

export function StoryAvatar({ avatarUrl, name, viewed, onClick }: StoryAvatarProps) {
  return (
    <button
      onClick={onClick}
      className="flex flex-shrink-0 flex-col items-center gap-1.5 focus:outline-none"
    >
      <div
        className={cn(
          "relative rounded-full p-[3px]",
          viewed
            ? "bg-gray-300"
            : "animate-gradient-rotate bg-gradient-to-tr from-cyan-500 via-blue-500 to-violet-500"
        )}
        style={viewed ? undefined : { backgroundSize: "200% 200%" }}
      >
        <div className="rounded-full bg-white p-[2px]">
          <img src={avatarUrl} alt={name} className="h-16 w-16 rounded-full object-cover" />
        </div>
      </div>
      <span className="max-w-[72px] truncate text-xs text-gray-700">{name}</span>
    </button>
  );
}
